import dynamic from 'next/dynamic'
import React, { FC } from 'react'

import { BarProps } from '@Components/CMS/Bars/types'

const DefaultBar = dynamic(() => import('@Components/CMS/Bars/Default'))
const SlimUrgencyBar = dynamic(() => import('@Components/CMS/Bars/Urgency/Slim'))
const TallUrgencyBar = dynamic(() => import('@Components/CMS/Bars/Urgency/Tall'))

export const BarFactory: FC<BarProps> = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  if (props.bar.type === 'urgency') {
    // eslint-disable-next-line react/destructuring-assignment
    if (props.bar.theme === 'campaign_small') {
      return <SlimUrgencyBar {...props} />
    }

    return <TallUrgencyBar {...props} />
  }

  return <DefaultBar {...props} />
}
